export const NEW_JOURNEY_NOTIFICATION_MODAL_PT_BR = {
	title: "Sua jornada de saque ficou mais simples",
	content:
		'A Zig unificou as jornadas de saque e antecipação em um único fluxo, trazendo mais agilidade para quem precisa acessar os recursos da operação. Clique em "Ver carteira" e experimente a nova jornada.',
	primaryActionLabel: "Fechar",
};

export type NewJourneyNotificationModalTranslations =
	typeof NEW_JOURNEY_NOTIFICATION_MODAL_PT_BR;
